// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.
import { HceSvFilter, SvFilterSvType } from '../../../../interfaces/hce/hce-sv-filter';
import { SvFilterSvType as SvFilterSvTypeConst } from '../../../../shared/constants/hce/hce-sv-filter-constants'

const EXCLUDED_KEYS: (keyof HceSvFilter)[] = [
  'filterName',
  'screenType',
];

/**
 * Counts active values in HceSvFilter for badge display.
 *
 * This function assumes the filter is already normalized
 * by normalizeHceSvFilter.
 *
 * Boolean values are counted only when true.
 */
export function countHceSvFilter(filter?: HceSvFilter): number {
  if (!filter) return 0;

  return Object.entries(filter).reduce((sum, [key, value]) => {
    if (EXCLUDED_KEYS.includes(key as keyof HceSvFilter)) return sum;
    if (value == null) return sum;

    if (Array.isArray(value)) {
      return sum + value.length;
    }

    if (typeof value === 'object') {
      return sum + Object.values(value).filter(
        v => v === true || (v != null && typeof v !== 'boolean')
      ).length;
    }

    return sum;
  }, 0);
}

/**
 * Type guard for SV filter SV type.
 */
export function isSvFilterSvType(v: unknown): v is SvFilterSvType {
  return (
    typeof v === 'string' &&
    Object.values(SvFilterSvTypeConst).includes(v as SvFilterSvType)
  );
}
